import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';

const LostAndFoundFormHistoryTableColumns = (): JSX.Element => (
  <SimpleTableRow header>
    <SimpleTableCell name="LOST_AND_FOUND" className="w-md-grow">
      Lost And Found
    </SimpleTableCell>
    <SimpleTableCell name="DATE_TIME">Date/Time</SimpleTableCell>
  </SimpleTableRow>
);

export default LostAndFoundFormHistoryTableColumns;
